// Utils
import { comparePaths } from './comparePaths';
import { depthOfPath } from './depthOfPath';
/**
 * Comparator for dot notation, ordering by depth first, then by it's parts if the same depth
 *
 * @param {string} a
 * @param {string} b
 *
 * @return {number}
 */
export var comparePathsByDepth = function (a, b) {
    var depthDiff;
    var depthA = depthOfPath(a);
    var depthB = depthOfPath(b);
    if (depthA > depthB) {
        depthDiff = 1;
    }
    else if (depthA < depthB) {
        depthDiff = -1;
    }
    else {
        depthDiff = comparePaths(a, b);
    }
    return depthDiff;
};
//# sourceMappingURL=comparePathsByDepth.js.map